import React, { useEffect, useState } from "react";
import styled from "styled-components";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";

import PCContainer from "../../components/atoms/layout/pcContainer";

import useDisplay from "../../hooks/useDisplay";
import { route } from "../../router/route";
import LSBdDisplay02 from "../../components/molecules/text/linSeedKr/Bd/lsBdDisplay02";
import LSRgH1HeadLine from "../../components/molecules/text/linSeedKr/Rg/lsRgH1HeadLine";
import TitleInput from "../../components/molecules/input/titleInput";
import MainBtn from "../../components/atoms/button/mainBtn";
import { toast } from "react-toastify";
import AuthApi from "../../api/auth.api";
import { errorHandler } from "../../util/errorHandler";

let timer;

const PwFind = () => {
  let min = 3;
  let sec = 0;

  const { isMobile, isTablet, isDesktop } = useDisplay();
  const isSmall = isMobile || isTablet;

  const navigate = useNavigate();

  const [id, setId] = useState("");
  const [idErrorM, setIdErrorM] = useState("");

  const [phone, setPhone] = useState("");
  const [phoneErrorM, setPhoneErrorM] = useState("");
  const [phoneCheck, setPhoneCheck] = useState(false);
  const [phoneCheckM, setPhoneCheckM] = useState("");

  const [smsToken, setSmsToken] = useState("");
  const [smsVerificationToken, setSmsVerificationToken] = useState("");

  const [certifiedNum, setCertifiedNum] = useState("");
  const [certifiedNumErrorM, setCertifiedNumErrorM] = useState("");
  const [certifiedNumCheckM, setCertifiedNumCheckM] = useState("");

  const [minState, setMinState] = useState(3);
  const [secState, setSecState] = useState(0);

  const [btnDisabled, setBtnDisabled] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);

    return () => {
      clearTimer("타이머 종료");
    };
  }, []);

  const countTimerStart = () => {
    timer = setInterval(countTimer, 1000);
  };

  const countTimer = () => {
    if (sec != 0) {
      sec = sec - 1;
      setSecState(sec);
    } else {
      if (min != 0) {
        min = min - 1;
        sec = 59;

        setSecState(sec);
        setMinState(min);
      } else {
        clearTimer("타이머 종료");
        setCertifiedNumErrorM("인증에 실패했습니다. 인증을 다시 시도하세요.");
      }
    }
  };

  function clearTimer(text) {
    clearInterval(timer);

    if (text === "타이머 종료") {
      min = 3;
      setMinState(3);
      sec = 0;
      setSecState(0);
    }
  }

  useEffect(() => {
    if (
      id &&
      idErrorM === "" &&
      phone &&
      phoneErrorM === "" &&
      certifiedNum &&
      certifiedNumCheckM !== ""
    ) {
      setBtnDisabled(false);
    } else {
      setBtnDisabled(true);
    }
  }, [id, idErrorM, phone, phoneErrorM, certifiedNum, certifiedNumCheckM]);

  useEffect(() => {
    if (id.length > 0) {
      setPhoneErrorM("");
      setPhoneCheckM("");
      setPhoneCheck(false);
      setCertifiedNumCheckM("");
      setSmsVerificationToken("");
    }
  }, [id]);

  useEffect(() => {
    if (phone.length > 0) {
      const regex = /^\d*$/;
      if (!regex.test(phone)) {
        return setPhoneErrorM("숫자만 입력해주세요.");
      }

      setPhoneErrorM("");
      setPhoneCheckM("");
      setPhoneCheck(false);
      setCertifiedNumCheckM("");
      setSmsVerificationToken("");
    }
  }, [phone]);

  useEffect(() => {
    if (phoneCheck) {
      setCertifiedNum("");
      setCertifiedNumErrorM("");
      setCertifiedNumCheckM("");
    }
  }, [phoneCheck]);

  const phoneCheckFunc = async () => {
    try {
      const obj = {
        phoneNumber: phone,
      };
      const response = await AuthApi.phoneCheck(obj);

      setPhoneCheck(false);
      setPhoneErrorM("전화번호로 가입된 회원이 없습니다.");
      setPhoneCheckM("");
    } catch (error) {
      phoneSendFunc();
    }
  };

  const phoneSendFunc = async () => {
    try {
      const obj = {
        phoneNumber: phone,
      };
      const response = await AuthApi.sendSMS(obj);

      clearTimer("타이머 종료");

      setSmsToken(response.data.data.smsToken);
      setSmsVerificationToken("");
      setPhoneCheck(true);
      countTimerStart();
      toast(
        response.data.data.authNumber
          ? "개발용 인증번호는 000000입니다."
          : "인증번호가 발송되었습니다.",
      );
    } catch (error) {
      setPhoneCheck(false);
      toast(`인증번호 발송에 실패하였습니다.`);
    }
  };

  const certifiedNumCheckFunc = async () => {
    try {
      const response = await AuthApi.verifySMS({
        phoneNumber: phone,
        authNumber: certifiedNum,
        smsToken,
      });
      setSmsVerificationToken(response.data.data.smsVerificationToken);
      setCertifiedNumErrorM("");
      setCertifiedNumCheckM("인증되었습니다.");
      setPhoneCheck(false);
      clearTimer("타이머 종료");
    } catch (error) {
      setSmsVerificationToken("");
      setCertifiedNumErrorM(
        "인증번호가 일치하지 않거나 만료되었습니다. 다시 시도하세요.",
      );
    }
  };

  const nextBtnFunc = async () => {
    try {
      const data = {
        phoneNumber: phone,
        smsVerificationToken,
      };
      const response = await AuthApi.idFind(data);

      if (response.data.data.joinType !== "NORMAL") {
        return toast("소설회원은 비밀번호를 재설정이 불가합니다.");
      }

      navigate(route.pw_change, {
        state: { phone, account: id, smsVerificationToken },
      });
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <PwFindSection>
        <PCContainer
          style={{
            padding: isSmall ? "80px 20px 80px 20px" : "80px 0px 150px 0px",
            width: "100%",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: isMobile ? "100%" : 790,
              padding: isMobile
                ? "0px"
                : isTablet
                ? "60px 140px"
                : "60px 205px",
              boxShadow: isMobile ? "none" : "0px 0px 6px 0px #0000001A",
              borderRadius: isMobile ? 0 : 30,
            }}
          >
            <LSBdDisplay02
              style={{
                textAlign: "center",
                marginBottom: 4,
              }}
            >
              비밀번호 찾기
            </LSBdDisplay02>
            <LSRgH1HeadLine
              style={{
                textAlign: "center",
                marginBottom: 32,
                color: "#898E99",
              }}
            >
              가입한 아이디와 전화번호를 입력해 주세요. <br />
              인증번호가 발송됩니다.
            </LSRgH1HeadLine>

            <TitleInput
              title={"아이디"}
              essential={true}
              placeholder={"아이디를 입력해 주세요."}
              type={"text"}
              onChange={(e) => {
                setId(e.target.value);
              }}
              value={id}
              warningMessage={idErrorM}
              style={{
                marginBottom: isMobile ? 24 : 20,
              }}
            />

            <TitleInput
              title={"전화번호"}
              essential={true}
              placeholder={"전화번호를 입력해 주세요."}
              type={"text"}
              onChange={(e) => {
                setPhone(e.target.value);
              }}
              value={phone}
              warningMessage={phoneErrorM}
              checkMessage={certifiedNumCheckM}
              style={{
                marginBottom: isMobile ? 24 : 20,
              }}
              isRightButton={true}
              isRightButtonText={"인증발송"}
              rightButtonOnClick={() => {
                if (phone && phoneErrorM === "") {
                  phoneCheckFunc();
                }
              }}
              maxLength={11}
            />

            {phoneCheck ? (
              <TitleInput
                title={"인증코드"}
                essential={true}
                placeholder={"인증코드 6자리를 입력해 주세요."}
                type={"text"}
                onChange={(e) => {
                  setCertifiedNum(e.target.value);
                }}
                value={certifiedNum}
                warningMessage={certifiedNumErrorM}
                checkMessage={certifiedNumCheckM}
                style={{
                  marginBottom: 20,
                }}
                isRightButton={true}
                isRightButtonText={"인증"}
                isRightButtonStyle={{
                  right: "-2%",
                }}
                isTimer={true}
                min={minState}
                sec={secState}
                timerStyle={{}}
                rightButtonOnClick={() => {
                  certifiedNumCheckFunc();
                }}
                maxLength={6}
              />
            ) : null}

            <MainBtn
              disabled={btnDisabled}
              onClick={() => {
                nextBtnFunc();
              }}
              style={{
                marginTop: 8,
              }}
            >
              <LSRgH1HeadLine
                style={{
                  color: "#FFFFFF",
                  textAlign: "center",
                }}
              >
                다음
              </LSRgH1HeadLine>
            </MainBtn>
          </div>
        </PCContainer>
      </PwFindSection>
    </>
  );
};

export default PwFind;

const PwFindSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
`;
